import Svg, { SvgProps } from './Svg';

export default function SparkSavingsIcon({ ...props }: SvgProps) {
  const id1 = 'linearGradient-savings' + Math.random().toString(16).slice(2);
  const id2 = 'linearGradient-savings' + Math.random().toString(16).slice(2);
  return (
    <Svg viewBox="0 0 96 96" fill="none" {...props}>
      <path
        d="M0 95.9998L30.3 30.3L96 0H2.57152C1.15134 0 0 1.15134 0 2.57152V95.9998Z"
        fill={`url(#${id1})`}
      />
      <path
        d="M96 0.000244141L65.7 65.7L0 96H93.4287C94.8489 96 96 94.8489 96 93.4287V0.000244141Z"
        fill={`url(#${id2})`}
      />
      <defs>
        <radialGradient
          id={id1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(48 149.521) rotate(-90) scale(149.521 149.521)">
          <stop stopColor="#FFEF79" />
          <stop offset="1" stopColor="#00C2A1" />
        </radialGradient>
        <radialGradient
          id={id2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(48 149.521) rotate(-90) scale(149.521 149.521)">
          <stop stopColor="#FFEF79" />
          <stop offset="1" stopColor="#00C2A1" />
        </radialGradient>
      </defs>
    </Svg>
  );
}
